export const CALIBRATION_CHECK_EVENT_TYPE = "CHECK_CALIBRAGEM";

function firstDefined() {
  for (let index = 0; index < arguments.length; index += 1) {
    const value = arguments[index];
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }
  return undefined;
}

function toNumber(value) {
  if (value === undefined || value === null || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function averageOf(values) {
  const clean = values.filter((value) => value != null && Number.isFinite(value));
  if (!clean.length) return null;
  return clean.reduce((sum, value) => sum + value, 0) / clean.length;
}

function sumOf(values) {
  const clean = values.filter((value) => value != null && Number.isFinite(value));
  if (!clean.length) return null;
  return clean.reduce((sum, value) => sum + value, 0);
}

export function isPlantingCalibrationPayload(payload) {
  if (!payload || typeof payload !== "object") return false;
  return [
    payload.adubo_kg,
    payload.semente_quantidade,
    payload.inoculante_l,
    payload.taxa_aplicada_adubo_kg_ha,
    payload.taxa_aplicada_semente_mil_ha,
    payload.taxa_aplicada_semente,
    payload.hectares_plantados,
    payload.hectares_painel,
    payload.hectares_painel_inicial,
  ].some((value) => value !== undefined && value !== null && value !== "");
}

export function calibrationCheckFromSyncRecord(record) {
  if (!record) return null;

  const payload =
    record.payloadParsed ||
    record.payloadData ||
    record.payload_data ||
    record.payload ||
    {};

  const eventType =
    record.event_type || payload.tipo_evento || payload.event_type || "";
  if (eventType !== CALIBRATION_CHECK_EVENT_TYPE) return null;
  if (!isPlantingCalibrationPayload(payload)) return null;

  const serviceOrderId = toNumber(
    firstDefined(payload.ordem_servico_id, payload.service_order_id)
  );

  return {
    uuid: record.uuid,
    serviceOrderId,
    timestamp:
      record.received_at ||
      record.timestamp ||
      payload.timestamp_utc ||
      payload.registrado_em_utc,
    operatorName:
      record.operator_name ||
      record.operatorName ||
      payload.nome_operador ||
      "",
    machineName: String(
      firstDefined(
        payload.nome_maquina,
        payload.id_maquina,
        record.equipment_name,
        record.equipmentName
      ) || ""
    ).trim(),
    productInfo: String(
      firstDefined(payload.informacoes_produto, payload.produto) || ""
    ).trim(),
    panelHectaresInitial: toNumber(payload.hectares_painel_inicial),
    panelHectares: toNumber(payload.hectares_painel),
    hectaresPlanted: toNumber(
      firstDefined(payload.hectares_plantados, payload.hectares_feitos)
    ),
    fertilizerKg: toNumber(payload.adubo_kg),
    fertilizerTargetKgHa: toNumber(payload.taxa_alvo_adubo_kg_ha),
    fertilizerAppliedKgHa: toNumber(payload.taxa_aplicada_adubo_kg_ha),
    seedQuantity: toNumber(payload.semente_quantidade),
    seedUnit: String(payload.semente_unidade || "").trim(),
    seedTarget: toNumber(payload.taxa_alvo_semente),
    seedAppliedThousandPerHa: toNumber(
      firstDefined(
        payload.taxa_aplicada_semente_mil_ha,
        payload.taxa_aplicada_semente
      )
    ),
    seedAppliedPerMeter: toNumber(payload.sementes_por_metro_aplicadas),
    inoculantL: toNumber(payload.inoculante_l),
    inoculantTargetLHa: toNumber(payload.taxa_alvo_inoculante_l_ha),
    inoculantAppliedLHa: toNumber(payload.taxa_aplicada_inoculante_l_ha),
    hectaresPerHour: toNumber(
      firstDefined(
        payload.media_esta_abastecida_ha_h,
        payload.ha_h,
        payload.hectares_por_hora
      )
    ),
    outsideTolerance: Boolean(payload.fora_da_tolerancia),
    payload,
  };
}

export function summarizeCalibrationChecks(rows) {
  const list = (rows || []).slice();
  if (!list.length) {
    return { count: 0, last: null, last3: null, total: null };
  }

  const last = list[list.length - 1];
  const last3Rows = list.slice(-3);

  const metric = (key) => ({
    last: last[key],
    last3: averageOf(last3Rows.map((row) => row[key])),
    total: averageOf(list.map((row) => row[key])),
  });

  return {
    count: list.length,
    last3Count: last3Rows.length,
    last,
    last3: {
      fertilizerAppliedKgHa: metric("fertilizerAppliedKgHa").last3,
      seedAppliedThousandPerHa: metric("seedAppliedThousandPerHa").last3,
      inoculantAppliedLHa: metric("inoculantAppliedLHa").last3,
      hectaresPerHour: metric("hectaresPerHour").last3,
      hectaresPlanted: averageOf(last3Rows.map((row) => row.hectaresPlanted)),
    },
    total: {
      fertilizerAppliedKgHa: metric("fertilizerAppliedKgHa").total,
      seedAppliedThousandPerHa: metric("seedAppliedThousandPerHa").total,
      inoculantAppliedLHa: metric("inoculantAppliedLHa").total,
      hectaresPerHour: metric("hectaresPerHour").total,
      hectaresPlanted: sumOf(list.map((row) => row.hectaresPlanted)),
    },
  };
}

